<template>
  <div>

    <loading :active.sync="isLoading"></loading>

    <div v-if="formProcess > 0">
      <div class="alert alert-success" v-if="formProcess == 200">
        {{ t.form.success }}
      </div>
      <div class="alert alert-danger" v-if="formProcess == 403">
        {{ t.error.access_denied_content }}
      </div>
      <div class="alert alert-danger" v-if="formProcess == 404">
        {{ t.error.notfound_content_list }}
      </div>
    </div>
    <symForm :data="formData" v-on:sended="getForm" :form="Form" :formProcess="formProcess" v-if="Form" />
  </div>
</template>

<script>

  import Choices from 'choices.js'

  import symForm from '@/components/form/symForm.vue'
  import casino from '@/mixins/casino.js'
  export default {
    name: 'ProviderForm',
    components: { symForm, },
    mixins: [casino],
    data () {
      return {
        isLoading: false,
        session: session,
        userLoader: true,
        t: this.$root.t,
        breadcrumb: [],
        Form: null,
        translationForm: null,
        formProcess: 0,
        formData: [],
      }
    },
    props: ['id'],
    mounted () {
      this.getForm();

    },
    watch: {
      'id' () {
        this.getForm();
      }
    },
    methods: {
      resetStatus () {
        this.formProcess = 0;
      },
      async getForm (data) {

        if(!this.isLoading) {
          this.isLoading = true;
          this.Form = null;
          this.formProcess = 0;
          if(data) {

            //this.Form = null;
            this.saveProviderForm(data, this.id)
              .then(response => {

                this.Form = response.body.result;
                this.formProcess = 200;

                this.isLoading = false;
                //swal('', this.t.processing.success, "success")

                setTimeout(this.resetStatus, 5000);
                setTimeout(() => { this.multiSelect() }, 500);

              }, response => {
                this.Form = response.body.result;
                this.formProcess = 400;
                this.isLoading = false;

                //swal(this.t.processing.error, this.t.processing.check, "error")
              })

          } else {
            this.getProviderFormById(this.id)
              .then(response => {

                this.Form = response.body.result;
                this.formData = response.body.form_data;
                this.isLoading = false;

              }, response => {
                this.isLoading = false;
                this.formProcess = response.status;
              })
          }


        }
      },
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/casino/form/provider.vue